import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { withRouter } from "react-router";

import "./sideMenuStyles.css";
import { MENU_LINKS, SETTING_LINKS } from "./SideMenuLinks";
import { getDashboardPath } from "../../../constants";

import Header from "../../Registration/Header";
import SideMenuIcon from "../../../components/uiElements/icons/profileIcons/SideMenuIcons";
import { getUserData } from "../../../utils/localStorage";
import { getConciergeServiceAction } from "../../../store/actions/dashboardActions";

const SideMenuDashboard = ({ practiceDetails, isEnableConciergeService }) => {
  let location = useLocation();
  const userData = getUserData();

  const newSubscriptionRequestCount = useSelector(state => state.dashboard.conciergeService.countData.newSubscriptionRequestCount);
  const newMessagesCount = useSelector(state => state.dashboard.conciergeService.countData.newMessagesCount);

  const activeStyle = {
    color: "#ffffff",
    background: `var(--primary-color)`,
  };
  const normalStyle = {
    color: "var(--pallet-color)",
    background: "white",
  };
  const [setting, setSetting] = useState(false);
  return (
    <div className="mainContainer">
      <div className="pb-5">
        <Header />
      </div>

      <div className="" style={{ marginTop: "50px" }}>
        {MENU_LINKS.map(link => {

          if (link.name == "Availability Schedule" && practiceDetails?.visit_now_doctor_status) {
            // When physician has visit now status then remove the schedule calendar item from menu list.
            return
          }
          if (link.name == "Concierge Service" && !isEnableConciergeService) {
            return
          }
          
          return (
            <div
              className="d-flex my-3 pl-3 align-items-center py-2"
              key={link.name}
              style={
                location.pathname.startsWith(getDashboardPath(`/${link.path}`))
                  ? activeStyle
                  : normalStyle
              }
            >
              {link.name !== "Settings" ? (
                <React.Fragment>
                  <Link
                    to={getDashboardPath(`/${link.path}`)}
                    className="linkContainer"
                  >
                    <SideMenuIcon
                      type={link.id}
                      className=""
                      active={location.pathname.startsWith(
                        getDashboardPath(`/${link.path}`)
                      )}
                    />
                    <p className="mb-0 sideMenuLink">
                      {link.name}
                      {userData &&
                        userData?.notification_count &&
                        link.name == "Notifications" && (
                          <span className="is-dot-icon mb-0" />
                        )}

                      {userData &&
                        userData?.chat_notify?.is_chat_listen &&
                        link.name == "Patients" && (
                          <span className="is-dot-icon mb-0" />
                        )}

                      {userData && (newMessagesCount > 0 || newSubscriptionRequestCount > 0) &&
                        link.name == "Concierge Service" && (
                          <span className="is-dot-icon mb-0" />
                        )}
                    </p>
                  </Link>
                </React.Fragment>
              ) : (
                <div
                  className="linkContainer"
                  onClick={() => setSetting(!setting)}
                >
                  <SideMenuIcon
                    type={link.id}
                    className=""
                    active={
                      location.pathname === getDashboardPath(`/${link.path}`)
                    }
                  />
                  <p className="mb-0 sideMenuLink">{link.name}</p>
                  <div className="w-100 text-right ml-auto mr-1">
                    <svg
                      className="ml-auto text-right"
                      width="12"
                      height="8"
                      viewBox="0 0 12 8"
                      fill="var(--pallet-color)"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.293 0.292969L6.00003 4.58597L1.70703 0.292969L0.29303 1.70697L6.00003 7.41397L11.707 1.70697L10.293 0.292969Z"
                        fill="var(--pallet-color)"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          );
        })}
        {setting &&
          SETTING_LINKS.map(link => {
            return (
              <div
                className="d-flex my-3 pl-3 align-items-center py-2"
                key={link.name}
                style={
                  location.pathname ===
                  getDashboardPath(`/setting/${link.path}`)
                    ? activeStyle
                    : normalStyle
                }
              >
                <Link
                  to={getDashboardPath(`/setting/${link.path}`)}
                  className="w-100 link d-flex align-items-center"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <span className="ml-2" style={{ width: "20px" }} />
                  <p className="mb-0 sideMenuLink">{link.name}</p>
                </Link>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const mapStoreToProps = ({ onboarding, dashboard }) => ({
  practiceDetails: onboarding?.practiceDetails,
  isEnableConciergeService: dashboard?.conciergeService?.isEnableConciergeService
});

export default withRouter(
  connect(mapStoreToProps,)(SideMenuDashboard)
);
